import { render, staticRenderFns } from "./messageControlBar.vue?vue&type=template&id=25cf030b&scoped=true&"
import script from "./messageControlBar.vue?vue&type=script&lang=js&"
export * from "./messageControlBar.vue?vue&type=script&lang=js&"
import style0 from "./messageControlBar.vue?vue&type=style&index=0&id=25cf030b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cf030b",
  null
  
)

export default component.exports